import React from 'react';
import {
	ImgAside,
	ImgBlank,
	ImgContent,
	ImgHeader,
	ImgHeaderSubheader,
	ImgMinimize,
	ImgSubheader,
} from '../components/Images';

// eslint-disable-next-line react/prop-types
const Item = ({ img }) => (
	<div className='col-md-4 d-flex flex-wrap justify-content-center mb-5'>
		<div className='rounded-2 px-5 pt-5 effect-hover'>
			<img
				src={img}
				alt=''
				className='img-fluid'
				style={{ borderRadius: '0.5rem 0.5rem 0 0' }}
			/>
		</div>
	</div>
);

const SectionLayouts = () => (
	<div
		id='pageLayouts'
		className='row scroll-margin layout-background g-4'
		style={{ paddingTop: '10rem', paddingBottom: '10rem' }}>
		<div className='col-12 text-center display-4 fw-bold'>
			<span>Page Layouts</span>
		</div>
		<div className='col-12 d-flex justify-content-center'>
			<div className='text-muted lead'>
				You can easily use any template you want for the pages you create.
			</div>
		</div>
		<div className='col-lg-8 offset-lg-2 mt-5'>
			<div className='row '>
				<Item img={ImgHeaderSubheader} />
				<Item img={ImgHeader} />
				<Item img={ImgSubheader} />
				<Item img={ImgContent} />
				<Item img={ImgAside} />
				<Item img={ImgMinimize} />
				<Item img={ImgBlank} />
			</div>
		</div>
	</div>
);

export default SectionLayouts;
